import { render, staticRenderFns } from "./appTest_bar.vue?vue&type=template&id=8851d8a8&scoped=true&"
import script from "./appTest_bar.vue?vue&type=script&lang=js&"
export * from "./appTest_bar.vue?vue&type=script&lang=js&"
import style0 from "./appTest_bar.vue?vue&type=style&index=0&id=8851d8a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851d8a8",
  null
  
)

export default component.exports